export default "__VITE_ASSET__DtyVZZsL__"